/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export interface PortalInquiryContactBodyDto {
  inquiryId: string;
  name: string;
  email: string;
  phone?: string;
  message: string;
  /** Cloudflare Turnstile token */
  turnstileToken: string;
}
